import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Container } from 'react-bootstrap';
import Footer from '../components/Footer';
import HeaderLocation from '../components/Header';
import RecipeCard from '../components/RecipeCard';

const MAX_CATEGORIES = 5;
const MAX_CARDS = 12;

class Bebidas extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCategory: null,
      categoryName: '',
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(category) {
    const { drinks: drinksObj } = this.props;
    const { drinks, ordinaryDrink, cocktail, milkFloatShake, otherUnknown, cocoa } = drinksObj || {};
    const { categoryName } = this.state;
    if (category !== categoryName && category !== 'All') {
      this.setState({ categoryName: category });
      switch (category) {
      case 'Ordinary Drink':
        if (ordinaryDrink && ordinaryDrink.length > 0) {
          this.setState({ selectedCategory: ordinaryDrink });
        } else {
          fetch(`https://www.thecocktaildb.com/api/json/v1/1/filter.php?c=${encodeURIComponent(category)}`)
            .then((res) => res.json())
            .then((data) => this.setState({ selectedCategory: data.drinks || [] }));
        }
        break;
      case 'Cocktail':
        if (cocktail && cocktail.length > 0) {
          this.setState({ selectedCategory: cocktail });
        } else {
          fetch(`https://www.thecocktaildb.com/api/json/v1/1/filter.php?c=${encodeURIComponent(category)}`)
            .then((res) => res.json())
            .then((data) => this.setState({ selectedCategory: data.drinks || [] }));
        }
        break;
      case 'Milk / Float / Shake':
        if (milkFloatShake && milkFloatShake.length > 0) {
          this.setState({ selectedCategory: milkFloatShake });
        } else {
          fetch(`https://www.thecocktaildb.com/api/json/v1/1/filter.php?c=${encodeURIComponent(category)}`)
            .then((res) => res.json())
            .then((data) => this.setState({ selectedCategory: data.drinks || [] }));
        }
        break;
      case 'Other/Unknown':
        if (otherUnknown && otherUnknown.length > 0) {
          this.setState({ selectedCategory: otherUnknown });
        } else {
          fetch(`https://www.thecocktaildb.com/api/json/v1/1/filter.php?c=${encodeURIComponent(category)}`)
            .then((res) => res.json())
            .then((data) => this.setState({ selectedCategory: data.drinks || [] }));
        }
        break;
      case 'Cocoa':
        if (cocoa && cocoa.length > 0) {
          this.setState({ selectedCategory: cocoa });
        } else {
          fetch(`https://www.thecocktaildb.com/api/json/v1/1/filter.php?c=${encodeURIComponent(category)}`)
            .then((res) => res.json())
            .then((data) => this.setState({ selectedCategory: data.drinks || [] }));
        }
        break;
      default:
        fetch(`https://www.thecocktaildb.com/api/json/v1/1/filter.php?c=${encodeURIComponent(category)}`)
          .then((res) => res.json())
          .then((data) => this.setState({ selectedCategory: data.drinks || [] }))
          .catch(() => this.setState({ selectedCategory: drinks || [] }));
        break;
      }
    } else {
      this.setState({ categoryName: '', selectedCategory: null });
    }
  }

  render() {
    const { categories, drinks: drinksProp } = this.props;
    const drinksCategories = (categories && Array.isArray(categories.drinksCategories)) ? categories.drinksCategories : [];
    const drinks = (drinksProp && Array.isArray(drinksProp.drinks)) ? drinksProp.drinks : [];
    const { selectedCategory, categoryName } = this.state;
    const rawList = (!selectedCategory || !Array.isArray(selectedCategory) || selectedCategory.length === 0) ? drinks : selectedCategory;
    const listToRender = Array.isArray(rawList) ? rawList : [];

    return (
      <div className="page-wrapper-custom">
        <HeaderLocation />
        <Container>
          <div className="categories-filter-wrapper">
            <Button
              size="sm"
              className={`filter-button orange ${categoryName === '' || categoryName === 'All' ? 'active' : ''}`}
              type="button"
              onClick={ (event) => this.handleClick(event.target.name) }
              name="All"
              data-testid="All-category-filter"
            >
              ✨ Todos
            </Button>
            {
              drinksCategories.map((category, index) => {
                if (index < MAX_CATEGORIES) {
                  return (
                    <Button
                      size="sm"
                      className={`filter-button orange ${categoryName === category.strCategory ? 'active' : ''}`}
                      key={ index }
                      type="button"
                      onClick={ (event) => this.handleClick(category.strCategory) }
                      data-testid={ `${category.strCategory}-category-filter` }
                    >
                      {category.strCategory}
                    </Button>
                  );
                }
                return null;
              })
            }
          </div>

          <div className="recipes-grid-custom">
            {
              listToRender.map((drink, index) => {
                if (index < MAX_CARDS && drink) {
                  return (
                    <Link
                      key={ drink.idDrink || index }
                      to={ `/bebidas/${drink.idDrink}` }
                      className="recipe-link"
                    >
                      <RecipeCard
                        idRecipeCard={ `${index}-recipe-card` }
                        idImg={ `${index}-card-img` }
                        srcImg={ drink.strDrinkThumb }
                        idCardName={ `${index}-card-name` }
                        mealName={ drink.strDrink }
                      />
                    </Link>
                  );
                }
                return null;
              })
            }
          </div>
        </Container>
        <Footer className="footer orange" />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  categories: state.categories,
  drinks: state.drinks,
  selectedCategory: state.selectedCategory,
});

Bebidas.propTypes = {
  drinks: PropTypes.objectOf(Object).isRequired,
  categories: PropTypes.objectOf(Object).isRequired,
};

export default connect(mapStateToProps)(Bebidas);
